var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\u0421\u043B\u043E\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425 268",
    style: {
      enableBackground: "new 0 0 425 268"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424"
    },
    d: "M401.301,248.173H35.646c-5.998,0-10.86-4.862-10.86-10.86V34.74c0-5.998,4.862-10.86,10.86-10.86 h365.655c5.998,0,10.86,4.862,10.86,10.86v202.573C412.161,243.311,407.299,248.173,401.301,248.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363C3C"
    },
    d: "M383.038,231.343H53.91c-3.895,0-7.052-3.157-7.052-7.052V47.762c0-3.895,3.157-7.052,7.052-7.052 h329.128c3.895,0,7.052,3.157,7.052,7.052v176.529C390.089,228.186,386.932,231.343,383.038,231.343z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#363C3C"
    },
    cx: 207.974,
    cy: 31.926,
    r: 4.317
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#363C3C"
    },
    cx: 218.474,
    cy: 31.926,
    r: 2.053
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#909499"
    },
    cx: 207.974,
    cy: 31.926,
    r: 1.646
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.943e0137bf1a9713708ee7c2900a1097.svg";
export { ForwardRef as ReactComponent };